import { EXTERNAL_ROUTES } from './external-routes';

export const UI_ROUTES = {
  HOME: '/',
  ZONE_EDITOR: '/zone-editor',
  ORG_BROWSER: '/org-browser',
  USER_MANAGEMENT: '/user-management',
  CREATE_NEW_USER: '/user-management/create-new-user',
  AUDIT_LOGS: '/audit-logs',
  TASKS: '/tasks',
  STORE_MANAGEMENT: '/store-management',
  CREATE_NEW_STORE: '/store-management/create-new-store',
  VIEW_AS_PORTAL: '/view_as',
  EPOS_UPLOAD: '/epos-upload',
  DEVICE_MAP: '/device-map',
  EPOS_UPLOAD_SIGN_IN: '/epos-upload/sign-in',
  EPOS_TRANSFORM: '/epos-upload/transform',
  EPOS_TRANSFORMER_EXTENDED: '/epos-upload/transform-extended',
  DEVICE_MANAGEMENT: '/device-management',
  DEVICE_STATUS: '/device-management/device-status',
  INSTALLS: '/device-management/installs',
  NEW_INSTALL: '/device-management/new-install',
  REPORT: '/report',
  REPORT_PAUSED_STATUS: '/report/paused-status',
  REPORT_BLACKLIST: '/report/blacklist',
  REPORT_GENERATE: '/report/generate',
  ZONE_SANDBOX: '/zone-sandbox',
  LOGIN: '/login',
  SIM_DETAIL: '/sim-detail',
  /** @deprecated */
  CUSTOMER_CENTRE: '/customer-centre',
} as const;

export type UiRoutes = (typeof UI_ROUTES)[keyof typeof UI_ROUTES];

export const NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP = {
  OTHERS: 'OTHERS',
  DEVICE_OPS: 'DEVICE_OPS',
  EMPLOYEE_DASHBOARD: 'EMPLOYEE_DASHBOARD',
} as const;

export type NestedAndExternalRouteIconKey =
  (typeof NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP)[keyof typeof NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP];

/** Internalise all labels */
export const ROUTES = [
  {
    path: UI_ROUTES.HOME,
    label: 'navigation.home',
  },
  {
    path: UI_ROUTES.ORG_BROWSER,
    label: 'navigation.orgBrowser',
  },
  {
    path: UI_ROUTES.ZONE_EDITOR,
    label: 'navigation.zoneEditor',
  },
  {
    path: UI_ROUTES.USER_MANAGEMENT,
    label: 'navigation.userManagement',
  },
  {
    path: UI_ROUTES.STORE_MANAGEMENT,
    label: 'navigation.storeManagement',
  },
  {
    label: 'navigation.deviceOps',
    icon_key: NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.DEVICE_OPS,
    sub_routes: [
      {
        path: UI_ROUTES.DEVICE_MANAGEMENT,
        label: 'navigation.overview',
      },
      {
        path: UI_ROUTES.DEVICE_STATUS,
        label: 'navigation.devicestatus',
      },
      {
        path: UI_ROUTES.INSTALLS,
        label: 'navigation.installs',
      },
      {
        path: UI_ROUTES.NEW_INSTALL,
        label: 'navigation.newInstall',
      },
    ],
  },
  {
    label: 'navigation.reports',
    icon_key: UI_ROUTES.REPORT,
    sub_routes: [
      {
        path: UI_ROUTES.REPORT,
        label: 'navigation.failedReportEntry',
      },
      {
        path: UI_ROUTES.REPORT_PAUSED_STATUS,
        label: 'navigation.reportPausedStatus',
      },
      {
        path: UI_ROUTES.REPORT_BLACKLIST,
        label: 'navigation.reportBlacklist',
      },
      {
        path: UI_ROUTES.REPORT_GENERATE,
        label: 'navigation.generateReport',
      },
    ],
  },
  {
    path: UI_ROUTES.EPOS_UPLOAD,
    label: 'navigation.eposUpload',
    search: '?tz=Europe%2FDublin',
  },
  {
    path: UI_ROUTES.TASKS,
    label: 'navigation.tasks',
  },
  {
    label: 'navigation.employeeDashboard',
    icon_key: NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.EMPLOYEE_DASHBOARD,
    external_url: EXTERNAL_ROUTES.employeeDashboard,
  },
  {
    label: 'navigation.others',
    icon_key: NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.OTHERS,

    sub_routes: [
      {
        path: UI_ROUTES.DEVICE_MAP,
        label: 'navigation.device.map',
      },
      {
        path: UI_ROUTES.SIM_DETAIL,
        label: 'navigation.sim.detail',
      },
      {
        path: UI_ROUTES.AUDIT_LOGS,
        label: 'navigation.auditLogs',
      },
      {
        path: UI_ROUTES.ZONE_SANDBOX,
        label: 'navigation.zoneSandbox',
      },
    ],
  },
];

export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
};
